import questionImg from "../../../assets/img/question-marks.png";
import questionImgWebp from "../../../assets/img/question-marks.webp";

const KeptAsking = () => (
    <section id="kept-asking">
        <div className="container-fluid pt-4 pb-4 text-center gg-bg-gradient-rb-h text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-11">
                    <h3 className="mb-5"><b>He kept asking himself…</b></h3>
                    <p className="fw-light">“What if I can’t get more?”<br />“What if I lose everything I’ve gained?”<br />“What if this really was the thing that finally worked… and I let it slip away?”</p>
                </div>
            </div>
        </div>
    </section>
);

export default KeptAsking;